import {
  DEPLOYMENT_ENVIRONMENT,
  IS_DEV_ENV,
  IS_PROD_ENV,
} from 'consts/appConsts';

export const getTagsDomain = () => {
  if (IS_PROD_ENV) {
    return `https://tags.chime.com`;
  } else if (IS_DEV_ENV) {
    return `https://tags-qa.chime.com`;
  } else {
    return `https://tags-${DEPLOYMENT_ENVIRONMENT}.chime.com`;
  }
};
